import { BusinessDataModel } from './BusinessDataModel';

export const LoginTypes = {
  SsoGoogle: 'SSO-Google',
  UsernameAndPassword: 'UsernameAndPassword',
} as const;

export type LoginType = typeof LoginTypes[keyof typeof LoginTypes];

export const AccountTypes = {
  BusinessOwner: 'BusinessOwner',
  Agency: 'Agency',
} as const;

export type AccountType = typeof AccountTypes[keyof typeof AccountTypes];

export const AgencyTermsAcceptance = {
  documentSet: 'agency-reseller-business-only',
  version: '2026-07-05',
} as const;

export interface RegistrationCompliancePayload {
  companyName?: string;
  acceptedTerms?: boolean;
  acceptedBusinessOnlyTerms?: boolean;
  acceptedTermsVersion?: string;
  acceptedTermsDocumentSet?: string;
}

export interface PasswordLoginRequest extends RegistrationCompliancePayload {
  email: string;
  password: string;
  accountType?: AccountType;
}

export interface PasswordLoginResponse {
  token: string;
  businessData: BusinessDataModel;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}
